<template>
  <div class="luck2021">
    <div class="luck2021__inn">
      <div class="luck2021__user">
        <resultUser :result="result" />
      </div>
      <div class="luck2021__list">
        <resultList :result="result" />
      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 10" width="70" height="10" class="luck2021__svg">
        <circle cx="5" cy="5" r="5" />
        <circle cx="35" cy="5" r="5" />
        <circle cx="65" cy="5" r="5" />
      </svg>
      <div class="luck2021__counselor">
        <resultCounselor :result="result" />
      </div>
      <div class="luck2021__sns">
        <resultSns
          :share-line-data="shareLineData"
          :share-twitter-data="shareTwitterData"
        />
      </div>
      <div class="luck2021__subsc" v-if="!subscription_flg">
        <prSubsc
            :imgPath="imgPath"
            :sbscUrl="sbscUrl"
        />
      </div>
    </div>
    <div class="otherCounselor">
      <div class="otherCounselor__inn">
        <div class="otherCounselor__title">2021年下半期の運勢</div>
        <div class="otherCounselor__list">
          <counselorList
            :list="counselors"
            :imgPath="imgPath + 'result/'"
            :exclude="result.counselor.menu_id"
            addClass="counselorList--result"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resultUser from "./resultUser";
import resultList from "./resultList";
import resultCounselor from "./resultCounselor";
import resultSns from "./resultSns";
import prSubsc from "./prSubsc";
import counselorList from "./counselorList";

export default {
  name: "Yearluck2021Result",
  components: {
    resultUser,
    resultList,
    resultCounselor,
    resultSns,
    prSubsc,
    counselorList,
  },
  data() {
    return {
      imgPath: '/static/img/yearluck/y2021/',
    }
  },
  props: {
    result: {
      type: Object,
      default () {
        return {}
      }
    },
    counselors: {
      type: Array,
      default () {
        return []
      }
    },
    shareLineData: {
      type: String,
      default() {
        return ''
      }
    },
    shareTwitterData: {
      type: String,
      default() {
        return ''
      }
    },
    subscription_flg: {
      type: Boolean,
      default: true
    },
    sbscUrl: {
      type: String,
      default: '/user/login'
    }
  },
}
</script>

<style scoped lang="scss">
.luck2021 {
  &__inn {
    padding: 24px 24px 0;
    max-width: 540px;
    margin: 0 auto;
  }
  &__user {}
  &__list {
    margin-bottom: 80px;
  }
  &__counselor {
    margin-bottom: 56px;
  }
  &__sns {
    margin-bottom: 80px;
  }
  &__subsc {
    margin-bottom: 80px;
  }
  &__svg {
    display: block;
    margin: 0 auto 40px;
    circle {
      fill: #DCDFE2;
    }
  }
}
.otherCounselor {
  background: #F5F7FA;
  padding: 40px 24px 44px;
  &__inn {
    max-width: 440px;
    margin: 0 auto;
  }
  &__title {
    text-align: center;
    font-weight: bold;
    font-size: 22px;
    line-height: 24px;
    letter-spacing: 1px;
    color: #32373F;
    margin: 0 0 32px;
  }
  &__list {}
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/yearluck2021Result.vue